import { createComponentElement } from "@modules/content/creators/createComponentElement";
import { useComponentData } from "@modules/content/hooks/useComponentData";
import { ContentComponent } from "@modules/content/types";
import { defaultPageSize } from "@modules/content/helpers/content";
import { ExtraProps } from ".";
import { useLockedContents } from "../hooks/useLockedContent";
import RectangleReviewItem from "@components/layouts/content/RectangleReviewItem";

export interface RectangleReviewItemParameters {
  title: string;
  image: string;
  shortDescription: string;
  promotionalText: string;
  categories: string;
}

export interface RectangleReviewItemItemParameters {
  image: string | null;
  icon: string | null;
}

const Component = createComponentElement((props, ref) => {
  const {
    getParameterValues,
    getItemsParameterValues,
    contents,
    content,
    isLoading,
  } = useComponentData<
    RectangleReviewItemParameters,
    RectangleReviewItemItemParameters
  >(
    {
      ...props,
      pageNumber: 1,
      pageSize: defaultPageSize,
    },
    ref
  );

  const { title, image, shortDescription } = getParameterValues([
    "title",
    "image",
    "shortDescription",
  ]);

  const { isLockedContent } = useLockedContents(content ? [content] : []);
  const lockedContents = isLockedContent.result;

  if (!content) return null;

  return (
    <RectangleReviewItem
      content={{ ...content, isLocked: lockedContents?.[0]?.isLocked }}
      parameterValues={{
        image,
        description: shortDescription,
        title,
      }}
      isLoading={isLoading}
      onItemPress={props.onItemPress}
    />
  );
});

export const RectangleReviewItemComponent: ContentComponent = {
  identifier: "COM:RECTANGLE:REVIEW:ITEM",
  component: Component,
};
